import React, { useEffect, useState, useMemo } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate } from 'react-router-dom';
import { useApiHook } from '../Helper/ApiHook/apiHook';
import { InputText } from "primereact/inputtext";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import HADataGrid from '../Common/HADataGrid';
import './Dashboard.css';



function Dashboard() {
    const navigate = useNavigate();
    const [{ user, dashboardFilters }, dispatch] = useStateValue();
    
    // Initialize local state from global state
    const [filters, setFilters] = useState({
        token: dashboardFilters?.token || '',
        firstName: dashboardFilters?.firstName || '',
        lastName: dashboardFilters?.lastName || '',
        email: dashboardFilters?.email || '',
        phone: dashboardFilters?.phone || ''
    });
    const [currentFilter, setCurrentFilter] = useState(dashboardFilters?.currentFilter || '');
    const [refresh, setRefresh] = useState(false);

    // No need for complex update logic - we'll update global state directly in our handlers

    const params = {
        "user_id": user.user_id
    }
    const url = 'api/ha/getHelperData';
    const [{ status, loading, data, error }, callAPI] = useApiHook(url,
        {
            verb: "post",
            useCache: false,
            token: user.token,
            params: params
        });

    useEffect(() => {
        user && callAPI();
        console.log(dashboardFilters);
    }, [user])

    useEffect(() => {

        if (status === 'fetched') {

            if (data.status === "OK") {

                dispatch({
                    type: 'ADD_DOCTORLIST',
                    item: data.data.doctorList.data
                });
                dispatch({
                    type: 'ADD_STATELIST',
                    item: data.data.stateList.data
                });
                dispatch({
                    type: 'ADD_STATUSLIST',
                    item: data.data.statusList.data
                });
               
            }

        }
        else if (status === 'error') {
            console.log(data);
            alert(error);

        }
    }, [status])


    useEffect(() => {
        setRefresh(prev => !prev);  // Toggle refresh flag
    }, [currentFilter]);
  
    //useEffect(() => {
    //    getSqlQuery();
    //}, [currentFilter]);

    const getSqlQuery = (currentFilter_) => {

        let baseCondition = ` c.created_at >= DATE_FORMAT(CURDATE(), '%Y-%m-01') - INTERVAL 1 MONTH`;

        let filter1 = currentFilter_ ? ` WHERE ${currentFilter_}` : ` WHERE ${baseCondition} AND c.status NOT IN ('Payment_Declined', 'created')`;
        let filter2 = currentFilter_ ? ` WHERE ${currentFilter_}` : ` WHERE rc.created_at >= DATE_FORMAT(CURDATE(), '%Y-%m-01') - INTERVAL 1 MONTH`;


        //let filter1 = (currentFilter === '' || currentFilter === null)  ?
        //` where c.status not in ('Payment_Declined', 'created')
        //and c.created_at >= DATE_FORMAT(CURDATE(), '%Y-%m-01') - INTERVAL 1 MONTH`
        //    : ` where ${currentFilter}`

        //let filter2 = (currentFilter === '' || currentFilter === null) ?
        //    ` where rc.created_at >= DATE_FORMAT(CURDATE(), '%Y-%m-01') - INTERVAL 1 MONTH`
        //    : ` where ${currentFilter}`

        // Privacy codes for diagnosis (dashboard only): a=Oral, b=Genital, c=other site; combinations ab/ac/bc/abc; e=empty/null
        const diagnosisPrivacyCase = `CASE
        WHEN c.diagnosis IS NULL OR TRIM(c.diagnosis) = '' THEN 'e'
        WHEN c.diagnosis LIKE '%Oral Herpes%' AND c.diagnosis LIKE '%Genital Herpes%' AND c.diagnosis LIKE '%another part of the body%' THEN 'abc'
        WHEN c.diagnosis LIKE '%Oral Herpes%' AND c.diagnosis LIKE '%Genital Herpes%' AND c.diagnosis NOT LIKE '%another part of the body%' THEN 'ab'
        WHEN c.diagnosis LIKE '%Oral Herpes%' AND c.diagnosis LIKE '%another part of the body%' AND c.diagnosis NOT LIKE '%Genital Herpes%' THEN 'ac'
        WHEN c.diagnosis LIKE '%Genital Herpes%' AND c.diagnosis LIKE '%another part of the body%' AND c.diagnosis NOT LIKE '%Oral Herpes%' THEN 'bc'
        WHEN TRIM(c.diagnosis) = 'Oral Herpes' THEN 'a'
        WHEN TRIM(c.diagnosis) = 'Genital Herpes' THEN 'b'
        WHEN TRIM(c.diagnosis) = 'Herpes simplex located on another part of the body' THEN 'c'
        ELSE '?'
        END`;

        let sql = `select 
        CONVERT_TZ(c.created_at, 'UTC', 'America/Los_Angeles') as 'created_at',
        'case' as casetype,
        c.id as 'id',
        null as 'refillID',
         c.token,
        c.dose_spot_patient_id,
         c.pharmacy_id,
        s.name as 'pharmacy_state',
        c.status,
        c.dose_spot_status,
        u.display_name as DrName,
        c.first_name,
        c.middle_initial,
        c.last_name,
        c.email,
        c.phone,
        c.dob,
        c.gender,
        u.dose_spot_user_id,
        c.skip_photo,
        case when c.member_id is null then 'No' else 'Yes' end as member,
        ${diagnosisPrivacyCase} as diagnosis,
        c.state_id,
        c.dermatologist_id,
        c.address_1,
        c.address_2,
        c.patient_state_id,
        st.name as 'patient_state',
        c.patient_city,
        c.patient_zip,
        c.paid,
        c.coupon,
        c.transaction_id
        from cases c
        left join doctor_notes n on n.case_id = c.id
        left join states s on s.id = c.state_id
        left join states st on st.id = c.patient_state_id
        left join users u on u.id = c.dermatologist_id 
        ${filter1}

        union

        SELECT
        CONVERT_TZ(rc.created_at, 'UTC','America/Los_Angeles') as 'created_at',
        'refill' as casetype,
        c.id as 'id',
        rc.id as 'refillID',
         rc.token,
        rc.dose_spot_patient_id,
        rc.pharmacy_id,
        s.name as 'pharmacy_state',
        rc.status,
        rc.dose_spot_status,
        u.display_name as DrName,
        c.first_name,
        c.middle_initial,
        c.last_name,
        c.email,
        rc.phone,
        c.dob,
        c.gender,
        u.dose_spot_user_id,
        c.skip_photo,
        case when rc.member_id is null then 'No' else 'Yes' end as member,
        ${diagnosisPrivacyCase} as diagnosis,
        rc.state_id,
        rc.dermatologist_id,
        c.address_1,
        c.address_2,
        c.patient_state_id,
        st.name as 'patient_state',
        c.patient_city,
        c.patient_zip,
        rc.paid_amount as paid,
        rc.coupon,
        rc.transaction_id
        FROM refill_cases rc
        inner join cases c on c.id = rc.case_id
        left join states s on s.id = rc.state_id
        left join states st on st.id = c.patient_state_id
        left join users u on u.id = rc.dermatologist_id
        ${filter2}
        order by created_at desc
        `
        return sql;
    }

    
    const config = useMemo(() => ({
        title: '',
        historyFlag: false,
        selectMultiple: false,
        primaryKey: 'id',
        serverName: 'default',
        databaseName: 'herpalert',
        tableName: 'cases',
        selectSql: getSqlQuery(currentFilter),  // Ensure query updates when filter changes
        joinTables: true,
        nonVisiableCols: ['dose_spot_user_id', 'patient_state_id', 'patient_zip', 'state_id', 'dermatologist_id', 'address_1', 'address_2', 'patient_city', 'patient_state'],
        nonEditAbleCols: [''],
        defaultValues: [],
        readOnlyCols: [],
        colSize: {
            created_at: '100px', 'id': '75px', casetype: '55px', refillID: '75px', member: '70px', dose_spot_patient_id: '85px', pharmacy_id: '75px', token: '85px', status: '110px', gender: '80px',
            DrName: '160px', first_name: '85px', last_name: '100px', middle_initial: '80px', email: '220px', phone: '120px', dob: '100px',
            pharmacy_city: '100px', pharmacy_state: '50px', pharmacy_zip: '80px', skip_photo: '40px', dose_spot_status: '70px', transaction_id: '80px',
            paid: '80px', coupon: '100px', diagnosis:'50px'
        },
        displayNames: {
            id: 'case', refillID: 'refill', casetype: 'type', dose_spot_patient_id: 'doseSpot', skip_photo: 'call', dose_spot_status: 'rx',
            pharmacy_state: 'state', pharmacy_zip: 'p zip', pharmacy_city: 'p city', created_at: 'date', member_id: 'member', pharmacy_id: 'pharmacy', transaction_id: 'transaction ID',
            first_name: 'first name', last_name: 'last name', middle_initial: 'middle', DrName: 'doctor', diagnosis:'d'
        },
        dropdownCols: [],
        links: {
            'id': { url: '/CaseDetail', params: ['id'] },
            'pharmacy_id': { url: '/Pharmacy', params: ['casetype', 'token', 'id', 'refillID', 'pharmacy_id'] },
            'dose_spot_patient_id': { url: '/DoseSpot', params: ['casetype', 'token', 'id', 'refillID', 'dose_spot_patient_id', 'pharmacy_id', 'dose_spot_user_id'] }
        },
        requiredFields: [],
        toolbar: true,
        showExport: false,
        bulkActionName: '',
        allowNew: false,
        allowEdit: false,
        allowDelete: false,
        allowExpand: false
    }), [currentFilter, refresh]);  // Re-create config when filter or refresh changes


        
    function handleInputChange(e, field) {
        const updatedFilters = { 
            ...filters, 
            [field]: e.target.value 
        };
        
        // Update local state
        setFilters(updatedFilters);
        
        // Update global state immediately with the full filter object
        dispatch({
            type: 'UPDATE_DASHBOARD_FILTERS',
            item: updatedFilters
        });
    }

    function handleSearch() {
        let whereClauses = [];
        if (filters.token) whereClauses.push(`c.token LIKE '%${filters.token}%'`);
        if (filters.firstName) whereClauses.push(`c.first_name LIKE '%${filters.firstName}%'`);
        if (filters.lastName) whereClauses.push(`c.last_name LIKE '%${filters.lastName}%'`);
        if (filters.email) whereClauses.push(`c.email LIKE '%${filters.email}%'`);
        if (filters.phone) whereClauses.push(`c.phone LIKE '%${filters.phone}%'`);

        let newCurrentFilter = '';
        if (whereClauses.length > 0) {
            newCurrentFilter = ` ${whereClauses.join(' AND ')}`;
        }
        
        // Update local state
        setCurrentFilter(newCurrentFilter);
        
        // Update global state with both the filter values and the current filter
      //  dispatch({
       //     type: 'UPDATE_DASHBOARD_FILTERS',
       //     item: currentFilter
       // });
       // dispatch({
       //     type: 'UPDATE_DASHBOARD_FILTERS',
       //     item: { 
       //         ...filters, 
       //         currentFilter: newCurrentFilter 
       //     }
       // });
        
        // Always toggle the refresh flag when search is clicked
        setRefresh(prev => !prev);
    }

    function handleClearFilters() {
        const emptyFilters = { 
            token: '', 
            firstName: '', 
            lastName: '', 
            email: '', 
            phone: '' 
        };
        
        // Update local state
        setFilters(emptyFilters);
        setCurrentFilter('');
        
        // Update global state to match the cleared filters
        dispatch({
            type: 'UPDATE_DASHBOARD_FILTERS',
            item: emptyFilters
        });
       // dispatch({
       //     type: 'UPDATE_DASHBOARD_FILTERS',
       //     item: { 
       //         ...emptyFilters, 
        //        currentFilter: '' 
         //   }
        //});
        
        // Refresh the grid
        setRefresh(prev => !prev);
    }

    return (
        <div className="dashboard">
            <Card>
                <div className="flex flex-row align-items-center gap-3 flex-wrap">
                    <InputText 
                        value={filters.token} 
                        onChange={(e) => handleInputChange(e, 'token')} 
                        placeholder="Token" 
                        className="p-inputtext-sm"
                    />
                    <InputText 
                        value={filters.firstName} 
                        onChange={(e) => handleInputChange(e, 'firstName')} 
                        placeholder="First Name" 
                        className="p-inputtext-sm"
                    />
                    <InputText 
                        value={filters.lastName} 
                        onChange={(e) => handleInputChange(e, 'lastName')} 
                        placeholder="Last Name" 
                        className="p-inputtext-sm"
                    />
                    <InputText 
                        value={filters.email} 
                        onChange={(e) => handleInputChange(e, 'email')} 
                        placeholder="Email" 
                        className="p-inputtext-sm"
                    />
                    <InputText 
                        value={filters.phone} 
                        onChange={(e) => handleInputChange(e, 'phone')} 
                        placeholder="Phone" 
                        className="p-inputtext-sm"
                    />
                    <div className="flex gap-2">
                        <Button label="Search" onClick={handleSearch} className="p-button-sm" />
                        <Button label="Clear" onClick={handleClearFilters} className="p-button-secondary p-button-sm" />
                    </div>
                </div>
            </Card>
            <HADataGrid key={`grid-${refresh}`} config={config} />
        </div>
    );
}

export default Dashboard;
